import { LightDiagnosticCypressAttribute } from
'@/modules/lightdiagnostic/constants/LightDiagnosticCypressAttribute';
<template>
  <section class="is-full-width has-text-centered has-border-radius has-background-secondary">
    <div class="p-4">
      <p
        class="is-size-2 has-text-weight-semibold m-b-15"
        :data-e2e="LightDiagnosticCypressAttribute.StarterBox.views.TITLE"
      >
        {{ title }}
      </p>
      <p
        class="is-size-4 m-b-20"
        :data-e2e="LightDiagnosticCypressAttribute.StarterBox.views.SUBTITLE"
      >
        {{ subTitle }}
      </p>
      <ButtonView
        type="is-primary"
        @click="onMatchClick"
        :data-e2e="LightDiagnosticCypressAttribute.StarterBox.views.BUTTON_TEXT"
      >
        {{ buttonText }}
      </ButtonView>
    </div>
  </section>
</template>

<script>
import { LightDiagnosticCypressAttribute } from '@/modules/lightdiagnostic/constants/LightDiagnosticCypressAttribute';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import Lang from '@/modules/core/app/services/Lang';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LightDiagnosticStarterBox',
  emits: ['on-match-clicked'],
  components: { ButtonView },
  props: {
    title: {
      type: String,
      default() {
        return Lang.t('lightdiagnostic.unsure-about-the-plan');
      }
    },
    subTitle: {
      type: String,
      default() {
        return Lang.t('lightdiagnostic.answer-couple-of-questions');
      }
    },
    buttonText: {
      type: String,
      default() {
        return Lang.t('lightdiagnostic.match-me-to-solution');
      }
    }
  },
  static: {
    LightDiagnosticCypressAttribute
  },
  methods: {
    onMatchClick() {
      this.$emit('on-match-clicked');
    }
  }
};
</script>
